import Icon from '../components/Icon.vue'

Icon.register({"ruble-sign":{"width":384,"height":512,"paths":[{"d":"M239.4 320C324.5 320 384 260.5 384 175.1S324.5 32 239.4 32H76C69.4 32 64 37.4 64 44V250.6H12C5.4 250.6 0 256 0 262.6V308C0 314.6 5.4 320 12 320H64V352H12C5.4 352 0 357.4 0 364V404C0 410.6 5.4 416 12 416H64V468C64 474.6 69.4 480 76 480H134.6C141.2 480 146.6 474.6 146.6 468V416H308C314.6 416 320 410.6 320 404V364C320 357.4 314.6 352 308 352H146.6V320H239.4zM146.6 100.7H225.3C272 100.7 300.2 129.9 300.2 175.1 300.2 220.9 272 250.6 224 250.6H146.6V100.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ruble-sign.js
// module id = mGiV
// module chunks = 0